import $ from 'jquery';

const onHashChange = () => {
	const hash = window.location.hash.substr( 1 )
	if ( gwoon_theme_vars.embed_popups.popups.includes( hash ) ) {
		render_embed( hash );
	}
};

const render_embed = function ( hash ) {
	var $reveal = $('<div />').addClass('reveal large video-modal').attr('id', 'embed-popup');
	var $page_content = $( '.page-content' );
	$page_content.append( $reveal );
	var $embed_popup = $( '#embed-popup' );
	new Foundation.Reveal( $embed_popup );
	$embed_popup.foundation( 'open' );

	$.ajax( {
		url: gwoon_theme_vars.rest_routes.get_embed_data,
		data: {
			hash: hash,
			cookie: window.icn_cookie_notice.get_consent()
		},
		method: 'GET',
		success: function ( data ) {
			if ( data.success ) {

				const $content = $(data.reveal_content);

				const $iframe = $content.find('iframe');


					const old_src = $iframe.attr('src');
				if(old_src !== undefined) {
					// Autoplay if youtube video
					if (old_src.indexOf("youtube.com/embed") >= 0) {
						$iframe.attr('src', old_src + '&autoplay=1');
						$iframe.attr('allow', 'autoplay');
					}
				}

				$embed_popup.append($content);

				$embed_popup.on('closed.zf.reveal', function() {
					$embed_popup.parent('.reveal-overlay').remove();
					window.location.hash = '';
				});
			}
		},
	} );
}

if ( document.readyState !== 'loading' ) {
	onHashChange();
} else {
	document.addEventListener( 'DOMContentLoaded', function () {
		onHashChange()
	} );
}

window.addEventListener( 'hashchange', onHashChange );